import parsely from '$app/analytics/parsely.ts';
import type { ParselyConversionType } from '$app/analytics/parsely.ts';

export class ParselyConversionComponent extends HTMLElement {
  get type(): ParselyConversionType | null {
    return this.getAttribute('type') as ParselyConversionType | null;
  }

  get label(): string | null {
    return this.getAttribute('label');
  }

  connectedCallback(): void {
    const type = this.type;
    const label = this.label;

    if (!type || !label) {
      console.warn(
        'ParselyConversionComponent: Missing type or label. Doing nothing.'
      );
      return;
    }

    parsely[type](label);
  }
}

declare global {
  interface Window {
    ParselyConversionComponent: typeof ParselyConversionComponent;
  }
  interface HTMLElementTagNameMap {
    'tmp-parsely-conversion': ParselyConversionComponent;
  }
}

if (!window.customElements.get('tmp-parsely-conversion')) {
  window.ParselyConversionComponent = ParselyConversionComponent;
  window.customElements.define(
    'tmp-parsely-conversion',
    ParselyConversionComponent
  );
}
